// OrganizacionSection.tsx
import React from "react";
import { Grid } from "@mui/material";

import GetNivelesOrganizacion from "../../../data/GetNivelesOrganizacion";
import GetAsignaturasOrganizacion from "../../../data/GetAsignaturasOrganizacion";

type SimpleIdNombre = { id: string; nombre: string };

type Props = {
  nivelOrg: SimpleIdNombre;
  asignaturaOrg: SimpleIdNombre;

  onNivelChange: (id: any, nombre: any) => void;
  onAsignaturaChange: (a: { id: string; nombre: string }) => void;
};

export default function OrganizacionSection({
  nivelOrg,
  asignaturaOrg,
  onNivelChange,
  onAsignaturaChange,
}: Props) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <GetNivelesOrganizacion
          selectedNivel={nivelOrg.id as any}
          onNivelChange={onNivelChange}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <GetAsignaturasOrganizacion
          nivelId={nivelOrg.id}
          selectedAsignatura={asignaturaOrg.id}
          onAsignaturaChange={onAsignaturaChange}
        />
      </Grid>
    </>
  );
}
